import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Usb({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M12 17C11.337 17 10.7011 17.2634 10.2322 17.7322C9.76339 18.2011 9.5 18.837 9.5 19.5C9.5 20.163 9.76339 20.7989 10.2322 21.2678C10.7011 21.7366 11.337 22 12 22C12.663 22 13.2989 21.7366 13.7678 21.2678C14.2366 20.7989 14.5 20.163 14.5 19.5C14.5 18.837 14.2366 18.2011 13.7678 17.7322C13.2989 17.2634 12.663 17 12 17ZM12 17V2M12 2L14.25 4.25M12 2L9.75 4.25M12 15.22L8.06 14.34C7.14 14.13 6.49 13.32 6.49 12.38V10.98M12 13.65L16.07 12.42C16.91 12.16 17.49 11.38 17.49 10.5V9.48M16.75 6H18.25C18.8023 6 19.25 6.44772 19.25 7V8.5C19.25 9.05228 18.8023 9.5 18.25 9.5H16.75C16.1977 9.5 15.75 9.05228 15.75 8.5V7C15.75 6.44772 16.1977 6 16.75 6ZM6.5 7.5C6.03587 7.5 5.59075 7.68437 5.26256 8.01256C4.93437 8.34075 4.75 8.78587 4.75 9.25C4.75 9.71413 4.93437 10.1592 5.26256 10.4874C5.59075 10.8156 6.03587 11 6.5 11C6.96413 11 7.40925 10.8156 7.73744 10.4874C8.06563 10.1592 8.25 9.71413 8.25 9.25C8.25 8.78587 8.06563 8.34075 7.73744 8.01256C7.40925 7.68437 6.96413 7.5 6.5 7.5Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Usb;